import React from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

import SimpleCard from '../cards/Card';

type MoreSocialProps = {
  title: string;
  url: string;
};

const MoreSocial = ({ title, url }: MoreSocialProps) => {
  return (
    <SimpleCard>
      <h2 className="text-lg">{title}</h2>
      <hr className="my-4" />
      <div className="flex flex-row items-center space-x-3">
        <FacebookShareButton url={url}>
          <FacebookIcon size={24} round></FacebookIcon>
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <TwitterIcon size={24} round></TwitterIcon>
        </TwitterShareButton>
        <TelegramShareButton url={url}>
          <TelegramIcon size={24} round></TelegramIcon>
        </TelegramShareButton>
        <WhatsappShareButton url={url}>
          <WhatsappIcon size={24} round></WhatsappIcon>
        </WhatsappShareButton>
        <LinkedinShareButton url={url}>
          <LinkedinIcon size={24} round></LinkedinIcon>
        </LinkedinShareButton>
        <EmailShareButton url={url}>
          <EmailIcon size={24} round></EmailIcon>
        </EmailShareButton>
      </div>
    </SimpleCard>
  );
};

export default MoreSocial;
